
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMoveItemGoogle as ObiMoveItemGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-move-item-google.js';
 
 
 

 
 export const ObiMoveItemGoogle = createComponent({
   react: React,
   tagName: 'obi-move-item-google',
   elementClass: ObiMoveItemGoogleElement,
   events: {
     
   }
  });
 
 